import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { Cookie } from 'lucide-react';

const CONSENT_KEY = 'roammate_cookie_consent';

export const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) return; // Cookies are a web-only concept
    try {
      const existing = localStorage.getItem(CONSENT_KEY);
      if (!existing) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch (e) {
      // localStorage unavailable (e.g. private browsing) — don't block the app
    }
  }, []);

  const respond = (choice) => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    } catch (e) {
      // ignore storage errors
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 inset-x-0 z-50 p-3 sm:p-4 animate-in slide-in-from-bottom duration-300"
    >
      <div className="max-w-2xl mx-auto bg-white/95 backdrop-blur-xl backdrop-saturate-150 border border-black/5 rounded-2xl shadow-[0_8px_32px_-8px_rgba(0,0,0,0.25)] p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <div className="w-9 h-9 rounded-xl bg-[#D96C4A]/10 flex items-center justify-center shrink-0">
          <Cookie className="w-4.5 h-4.5 text-[#D96C4A]" />
        </div>
        <p className="text-sm text-[#5C5C5C] leading-relaxed flex-1">
          We use essential cookies to keep you signed in and remember your preferences, plus limited
          analytics to improve RoamMate. See our{' '}
          <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#D96C4A] underline underline-offset-2">
            Privacy Policy
          </a>{' '}
          for details.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => respond('declined')}
            data-testid="cookie-consent-decline"
            className="text-sm font-medium text-[#5C5C5C] hover:text-[#1A1A1A] px-4 py-2 rounded-full transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => respond('accepted')}
            data-testid="cookie-consent-accept"
            className="text-sm font-semibold text-white bg-[#D96C4A] hover:bg-[#BF5939] px-5 py-2 rounded-full transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
